export default __webpack_public_path__ + "21797adf967bfcdc4b157ebdd2354ead.woff?proxy=wpt-abc";